export default "__VITE_ASSET__BJU7IyUG__"